import type { AppState, ScientificFrame } from './types';
import { applyResearchReleaseReview } from './researchRelease';
import { calculateScientificFrame as calculateFreeSpaceFrame } from './freeSpaceKernel';
import {
  calculateDceFrame,
  calculateDynamicBoundaryFrame,
  calculateHomodyneFrame,
  calculateLambShiftFrame,
  calculateStaticCasimirFrame
} from './historicalKernels';

export const calculateScientificFrame = (state: Readonly<AppState>, animationTimeSeconds: number): ScientificFrame => {
  let frame: ScientificFrame;
  switch (state.era) {
    case '2010s': frame = calculateDceFrame(state, animationTimeSeconds); break;
    case '1990s-2000s': frame = calculateHomodyneFrame(state, animationTimeSeconds); break;
    case '1970s-1980s': frame = calculateDynamicBoundaryFrame(state, animationTimeSeconds); break;
    case '1950s-1960s': frame = calculateStaticCasimirFrame(state, animationTimeSeconds); break;
    case '1940s': frame = calculateLambShiftFrame(state, animationTimeSeconds); break;
    case 'modern':
    default: frame = calculateFreeSpaceFrame(state, animationTimeSeconds); break;
  }
  return applyResearchReleaseReview(state, frame);
};
